import {aiStore} from "../../index";
import {handleAbort} from "./PdfParser";


async function getImageBlob(src) {

    const urlMappings = {
        'https://via.placeholder.com/300x200': 'https://picsum.photos/300/200',
        'https://via.placeholder.com/400x300': 'https://picsum.photos/400/300',
        'https://via.placeholder.com/50x50': 'https://picsum.photos/50/50'
    };

    const actualSrc = urlMappings[src] || src;

    if (actualSrc.startsWith('data:image/')) {
        const [header, base64Data] = actualSrc.split(',');
        const mimeType = header.match(/data:([^;]+)/)[1];

        const binaryString = atob(base64Data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return new Blob([bytes], { type: mimeType });
    } else if (actualSrc.startsWith('http://') || actualSrc.startsWith('https://')) {
        try {
            const response = await fetch(actualSrc);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const blob = await response.blob();
            return blob;
        } catch (error) {
            return null;
        }
    } else {
        return null;
    }
}


async function convertHtmlToString(file, fileContent, isEmbedding, abortedFiles) {
    const html = fileContent;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const imgElements = Array.from(doc.querySelectorAll('img'));
    const imgCount = imgElements.length
    for (let i = 0; i < imgCount; i++) {
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        const img = imgElements[i];
        const oldSrc = img.getAttribute('src');

        if (oldSrc) {
            const newId = await handleImageFile(oldSrc, file, i);
            if (!newId){
                img.remove();
            } else {
                img.setAttribute('src', newId);
            }
        }else {
            img.remove();
        }
        aiStore.sendAiProgressLoaderValue(file.name, (i+1)*100/(imgCount+2));
    }

    const updatedHtml = doc.documentElement.outerHTML;
    const chunks = splitHtmlIntoChunks(updatedHtml);
    return chunks;
}

async function handleImageFile(oldSrc, file, i) {
    let ext = null;

    if (oldSrc.startsWith('data:image/')) {
        ext = oldSrc.split(';')[0].split('/')[1];
    } else {
        try {
            const url = new URL(oldSrc);
            const pathname = url.pathname;
            const pathExt = pathname.split('.').pop().toLowerCase();

            const validExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
            ext = validExts.includes(pathExt) ? pathExt : 'jpg';

        } catch (error) {
            ext = oldSrc.split('.').pop().toLowerCase().replace(/[?#].*$/, '');
            if (!ext || ext === oldSrc) ext = 'jpg';
        }
    }

    const blob = await getImageBlob(oldSrc);
    let newId = '';

    if (blob) {
        if (blob.type && blob.type.startsWith('image/')) {
            const blobExt = blob.type.split('/')[1];
            if (blobExt && blobExt !== 'jpeg') ext = blobExt;
        }

        newId = await uploadImageFromFile(blob, file, i, ext);
    }
    return newId;
}

function splitHtmlIntoChunks(html, maxChunkSize = 5000) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const chunks = [];
    let currentChunk = '';

    const container = doc.body || doc.documentElement;
    const elements = container.children;

    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const elementHtml = element.outerHTML;

        if (currentChunk.length + elementHtml.length > maxChunkSize && currentChunk.length > 0) {
            chunks.push(currentChunk);
            currentChunk = elementHtml;
        } else {
            currentChunk += elementHtml;
        }
    }

    if (currentChunk.length > 0) {
        chunks.push(currentChunk);
    }

    return chunks;
}

async function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
    });
}


async function uploadImageFromFile(blob, file, index, ext) {
    try {
        const fileName = `${file.name.replace(/[<>:"/\\|?*]/g, '_').replace(/\s+/g, '_').replace(/_{2,}/g, '_').replace(/^_|_$/g, '')}_image_${index}.${ext}`;
        const mimeType = blob.type || `image/${ext}`;
        const imageFile = new File([blob], fileName, {
            type: mimeType,
            lastModified: Date.now()
        });

        const associatedFiles = await aiStore.uploadFiles([imageFile], false)
        return associatedFiles[0]._id
    } catch (error) {
        return '';
    }
}

async function processHtmlFile(htmlFile, isEmbedding, abortedFiles) {
    try {
        const fileContent = await readFileAsText(htmlFile);
        const chunks = await convertHtmlToString(
            { name: htmlFile.name, size: htmlFile.size },
            fileContent,
            isEmbedding,
            abortedFiles
        );
        return chunks;
    } catch (error) {
        throw error;
    }
}



export {
    convertHtmlToString,
    handleImageFile,
    splitHtmlIntoChunks,
    getImageBlob,
    readFileAsText,
    uploadImageFromFile,
    processHtmlFile
};

